import styled, { css } from 'styled-components';
import { checkPixel } from 'utils';

export const common = css`
  ${({ $padding }) => $padding && `padding:${$padding}`};
  ${({ $gap }) => $gap && `gap:${checkPixel($gap)}`};
  ${({ $flex }) => $flex && `flex:${$flex}`};
  ${({ $justifyContent }) => $justifyContent && `justify-content:${$justifyContent}`};
  ${({ $alignItems }) => $alignItems && `align-items:${$alignItems}`};
  ${({ $height }) => $height && `height:${checkPixel($height)}`};
  ${({ $width }) => $width && `width:${checkPixel($width)}`};
  ${({ $maxWidth }) => $maxWidth && `max-width:${checkPixel($maxWidth)}`};
  ${({ $minWidth }) => $minWidth && `min-width:${checkPixel($minWidth)}`};
  ${({ $cursor }) => $cursor && `cursor:${$cursor}`};
  ${({ $margin }) => $margin && `margin:${$margin}`};
  ${({ $flexDirection }) => $flexDirection && `flex-direction:${$flexDirection}`};
  ${({ $gridColumn }) => $gridColumn && `grid-column: span ${$gridColumn}`};

  ${({ $hover }) =>
    $hover &&
    `
  @media (hover: hover) and (pointer: fine) {
    transition: all 150ms;
    cursor:pointer;

    &:hover{
      opacity: 0.6;
    }
  }`};

  @media ${({ theme }) => theme.device.tablet} {
    ${({ $tGap }) => $tGap && `gap:${checkPixel($tGap)}`};
    ${({ $tFlexDirection }) => $tFlexDirection && `flex-direction:${$tFlexDirection}`};
    ${({ $tPadding }) => $tPadding && `padding:${$tPadding}`};
    ${({ $tAlignItems }) => $tAlignItems && `align-items:${$tAlignItems}`};
  }

  @media ${({ theme }) => theme.device.mobile} {
    ${({ $mDisplay }) => $mDisplay && `display:${$mDisplay}`};
    ${({ $mWidth }) => $mWidth && `width:${checkPixel($mWidth)}`};
    ${({ $mMinWidth }) => $mMinWidth && `min-width:${checkPixel($mMinWidth)}`};
    ${({ $mMaxWidth }) => $mMaxWidth && `max-width:${checkPixel($mMaxWidth)}`};
    ${({ $mGap }) => $mGap && `gap:${checkPixel($mGap)}`};
    ${({ $mPadding }) => $mPadding && `padding:${$mPadding}`};
    ${({ $mMargin }) => $mMargin && `margin:${$mMargin}`};
    ${({ $mFlexDirection }) => $mFlexDirection && `flex-direction:${$mFlexDirection}`};
    ${({ $mJustifyContent }) => $mJustifyContent && `justify-content:${$mJustifyContent}`};
    ${({ $mAlignItems }) => $mAlignItems && `align-items:${$mAlignItems}`};
  }
`;

export const Div = styled.div`
  ${common}
`;

export const ColDiv = styled.div`
  display: flex;
  flex-direction: column;
  ${common}
`;

export const RowDiv = styled.div`
  display: flex;
  ${common}
`;

export const Container = styled(ColDiv)`
  width: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    padding: 0 24px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    gap: 24px;
  }
`;
export const AlertStyle = styled.div`
  ${common};
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 20px 30px;
  border-radius: 10px;
  min-width: 320px;
`;